import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useBuilderEditor } from '../../../../features/builder/BuilderEditorContext';

const HelpTab = () => {
  const { helpText, setHelpText, markUnsaved } = useBuilderEditor();

  return (
    <div>
      <label className="builder-label">Help text / Description</label>
      <ReactQuill
        value={helpText}
        onChange={(content) => { setHelpText(content); markUnsaved(); }}
        theme="snow"
      />
    </div>
  );
};

export default HelpTab;
